import { CompareValueEnum } from '../utils';
import { DECIMAL_TYPES, ICurrencyFormat } from 'utils/types';
import { getFormattedCurrency, getFormattedPercentage } from 'utils/format';
import numeral from 'numeral';
import { cellRendererFramework } from 'components/Tables/TableComponents';

export const getColumnDefsByType = (
  type: string,
  format: ICurrencyFormat,
  isPercentage?: boolean
) => {
  if (type === CompareValueEnum.HEADCOUNT) {
    return [
      {
        headerName: 'CE Role',
        field: 'category',
        minWidth: 130,
        sortable: true,
      },
      {
        headerName: 'Client Role',
        field: 'clientCategory',
        minWidth: 130,
        sortable: true,
      },
      {
        headerName: 'Number of FTE',
        field: 'value',
        type: 'numericColumn',
        minWidth: 130,
        sortable: true,
        valueFormatter: (params: any) =>
          numeral(params.value).format('0,0.[0]'),
      },
      {
        headerName: isPercentage ? '% of revenue' : 'Spend',
        field: 'spend',
        type: 'numericColumn',
        minWidth: 130,
        sort: 'desc',
        sortable: true,
        cellRendererFramework: (params: any) =>
          cellRendererFramework(
            params.value,
            isPercentage
              ? getFormattedPercentage(params.value, {
                  ...format,
                  decimal: '.0000' as keyof DECIMAL_TYPES,
                })
              : getFormattedCurrency({
                  currencyFormat: format,
                  value: params.value,
                  isIdealDenomination: true,
                  isCurrencySign: true,
                  isUnitSign: true,
                })
          ),
      },
      {
        headerName: 'Average Spend',
        field: 'avarageSpend',
        type: 'numericColumn',
        minWidth: 130,
        sortable: true,
        valueFormatter: (params: any) =>
          getFormattedCurrency({
            currencyFormat: format,
            value: params.value,
            isIdealDenomination: true,
            isCurrencySign: true,
            isUnitSign: true,
          }),
      },
    ];
  }

  return [
    {
      headerName: 'Service Tower',
      field: 'serviceTower',
      minWidth: 130,
      sortable: true,
    },
    {
      headerName: 'Vendor',
      field: 'vendor',
      minWidth: 130,
      sortable: true,
    },
    {
      headerName: 'Description',
      field: 'description',
      minWidth: 130,
      sortable: true,
    },
    {
      headerName: 'Expense Type',
      field: 'expenseType',
      minWidth: 130,
      sortable: true,
    },
    {
      headerName: 'Contribution',
      field: 'contribution',
      minWidth: 130,
      sortable: true,
    },
    {
      headerName: isPercentage ? '% of revenue' : 'Spend',
      field: 'cost',
      type: 'numericColumn',
      minWidth: 130,
      sortable: true,
      sort: 'desc',
      cellRendererFramework: (params: any) =>
        cellRendererFramework(
          params.value,
          isPercentage
            ? getFormattedPercentage(params.value, {
                ...format,
                decimal: '.0000' as keyof DECIMAL_TYPES,
              })
            : getFormattedCurrency({
                currencyFormat: format,
                value: params.value,
                isIdealDenomination: true,
                isCurrencySign: true,
                isUnitSign: true,
              })
        ),
    },
  ];
};
